import { WizardStepTracker } from '../../../wizard/interfaces/wizard-step-tracker';
import { CreateDestinationStepPaths } from './interface';

export class DestinationTypeResolver {
  resolve(tracker: WizardStepTracker): string | null {
    const destinationTypeStepData = tracker.getStepData(
      CreateDestinationStepPaths.SELECT_DESTINATION_TYPE
    );

    if ('destinationType' in destinationTypeStepData) {
      return destinationTypeStepData.destinationType as string;
    }

    return null;
  }
}
